module.exports = __webpack_public_path__ + "img/brennan_scarlett.c988ff91.png";